import styles from "./center-btn.module.css";
import React from "react";
import {cn} from "@/lib/utils";

interface IProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
    icon: React.ReactNode;
    label: string;
    active?: boolean;
}

export default function CenterBtn({icon, label, active, className, ...props}: IProps) {
    return (
        <button
            className={cn('bg-transparent h-[41px] cursor-pointer rounded-[8px] text-noble-black-300 flex flex-nowrap items-center px-[42px]', {['text-noble-black-900 border border-stroke-gold']: active}, {[styles.ButtonActive]: active}, className)}
            {...props}>
            <div>{icon}</div>
            <span className={'ml-[8px] font-semibold text-nowrap'}>{label}</span>
        </button>
    )
}
